(function() {
  "use strict";

  angular.module("localization").config(config);

  function config($translateProvider) {
    var data = {
      // http://www.xe.com/ibancalculator/sample/?ibancountry=serbia
      session: {
        inactiveUser:
          "Zbog neaktivnosti isteklo Vam je vrijeme za rad u aplikaciji. Molimo prijavite se ponovo."
      },
      filter: {
        maxDateRange: "Maksimalni raspon datuma je jedna godina."
      },
      inputFields: {
        IBAN: "9999 9999 9999 9999 9"
      },
      core: {
        moneyFormat: {
          mask: "#.###.##0,00",
          placeholder: "eg: 000.000,00"
        },
        period: {
          today: "Danas",
          yesterday: "Jučer/Juče",
          thisWeek: "Sedam dana",
          thisMonth: "Mjesec dana",
          thisYear: "Godina dana",
          all: "Sve",
          allMessages: "Sve poruke"
        },
        paymentOrder: "Nalog broj",
        investOrder: "Investicija broj",
        successDelete: "je uspješno izbrisan.",
        investSuccessDelete: "je uspješno izbrisana.",
        termDepositPayoutType: {
          "2": "",
          "2e": "",
          "16": "",
          "16e": "",
          "17": "",
          "17e": "",
          "18": "",
          "18e": "",
          "19": "",
          "19e": "",
          "3": "",
          "3e": ""
        },
        termDepositStatus: {
          realised: "Realiziran/Realizovan",
          unrealised: "Neostvaren",
          cancelled: "Otkazan",
          receivednotexecuted: "U obradi"
        },
        confirmation:
          "Reklamacija na transakciju je uspješno poslana u bazu podataka.",
        error: "Greška",
        sweetAlertTranslation: {
          yes: "Da",
          no: "Ne",
          areYouSure: "Jeste li sigurni?"
        },
        logoutModalTranslation: {
          logoutBtn: "Da",
          logoutMsg: "Jeste li sigurni?",
          cancel: "Ne"
        },
        sameAccounts: "Greška: Isti računi!",
        paymentSignedStatus: {
          inprocessing: "U obradi"
        },
        today: "Danas",
        passwordChangedMsg: "Uspješno ste promijenili lozinku !",
        noAccounts: "Nema dostupnih računa",
        additionalDataChangedMsg: "Podaci su uspješno ažurirani !",
        datePicker: {
          doneBtn: "Uredu",
          clearBtn: "Obriši"
        }
      }
    };
    $translateProvider.translations("bh", data);
  }
})();
